/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'
import { FormattedMessage } from 'react-intl';

import MfaCodeEntryView from './MfaCodeEntry.view';

import { authToken } from 'lib/storagePolyfill';
import PasswordStrength from 'lib/PasswordStrength';

class MfaCodeEntry extends React.Component {

  constructor(props) {
    super(props);

    this.submitMfaCode = this.submitMfaCode.bind(this);
    this.handleResendCode = this.handleResendCode.bind(this);
    this.requestMfaCode = this.requestMfaCode.bind(this);

    this.state = {
      resendTimeout: null,
      mfaCode: '',
      isResending: false,
      isMfaCodeGoodEnough: false,
      displayMobileNumber: props.displayMobileNumber || '',
    };
  }

  componentDidMount() {
    this.requestMfaCode();
  }

  requestMfaCode() {
    const token = this.props.token || authToken.get();
    const { sendMfaCode } = this.props;
    sendMfaCode(token)
    .then((res) => {
      this.setState({
        displayMobileNumber: res.mobile_number,
      });
      return null;
    })
    .catch(apiError => {
      debugger
    });
  }

  submitMfaCode() {
    if (!this.state.isMfaCodeGoodEnough) {
      this.setState({
        errorMessage: <FormattedMessage id="error.2fa-code-validator.message" />,
      });
      return;
    }

    this.props.submitMfaCode(this.state.mfaCode)
    .catch((apiError) => {
      this.setState({
        errorMessage: <FormattedMessage id={apiError.messageKey()} />,
      });
      // return Promise.reject(apiError);
    });
  }

  handleResendCode() {
    if (this.state.isResending) { return; }

    this.requestMfaCode();

    const resendTimeout = setTimeout(() => {
      clearTimeout(this.state.resendTimeout);
      this.setState({
        resendTimeout: null,
        isResending: false,
      });
    }, 5000);

    this.setState({
      resendTimeout,
      isResending: true,
    });

    if (this.props.onResend) {
      this.props.onResend();
    }
  }

  render() {
    return (
      <MfaCodeEntryView
        goBack={this.props.goBack}
        organizationName={this.props.organizationName}
        mfaCode={this.state.mfaCode}
        displayMobileNumber={this.state.displayMobileNumber}
        onChange={(e) => {
          const mfaCode = e.target.value;
          this.setState({
            mfaCode,
            isMfaCodeGoodEnough: mfaCode.length > 5,
          });
        }}
        onFocus={() => { this.setState({ errorMessage: '' }); }}
        errorMessage={this.state.errorMessage}
        onResendCode={this.handleResendCode}
        isResending={this.state.isResending}
        submitMfaCode={this.submitMfaCode}
        isMfaCodeGoodEnough={this.state.isMfaCodeGoodEnough}
      />
    );
  }
}

export default MfaCodeEntry;